import { use } from "react";
import TradsContext from "./TradsContext";

// Custom hook for easy access
export const useTrads = () => {
  const ctx = use(TradsContext);
  if (!ctx) throw new Error('useTrads must be inside TradsProvider');
  return ctx;
};